import { render } from "./LocaleChooserComponent.vue?vue&type=template&id=4c487a4e"
import script from "./LocaleChooserComponent.vue?vue&type=script&lang=js"
export * from "./LocaleChooserComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__